import React from "react";

function Icon({
  children,
  onClick = undefined,
  textColor = "",
  scaleOnHover = "",
  textSize = "2xl",
}) {
  return (
    <div
      className={`cursor-pointer flex items-center justify-center text-${textSize} text-${textColor} transition duration-300 ${scaleOnHover}`}
      onClick={onClick ? () => onClick((open) => !open) : undefined}
    >
      {children}
    </div>
  );
}

export default Icon;
